export interface IMarketingBlocksResponse {
	status: string;
	data: Data;
}
interface Data {
	provider: string;
	version: string;
	app_name: string;
	app_id: number;
	app_revision_id: number;
	app_revision_status: string;
	placements?: IMBPlacementsEntity[] | null;
}
interface IMBPlacementsEntity {
	placement_key: IPlacementKeyTypes;
	blocks?: IMBBlock[] | null;
}
export interface IMBBlock {
	id: number;
	type: string;
	title: string;
	translations?: TranslationsEntity[] | null;
}
interface TranslationsEntity {
	langcode: string;
	revision_id: number;
	field_values: IMBFieldValues;
}
export interface IMBFieldValues {
	heading?: string | null;
	body?: string | null;
	ctas?: CtasEntity[] | null;
	image?: Image | null;
	background?: Background | null;
	type?: string | null;
	title?: string | null;
	message?: string | null;
	allow_expansion?: boolean | null;
	items?: IMBItemsEntity[] | null;
}
interface CtasEntity {
	cta_url: string;
	cta_text: string;
}
interface Image {
	url: string;
	alt: string;
}
interface Background {
	image: Image1;
	color: string;
	styles: string;
}
interface Image1 {
	url: string;
	alt: string;
}
export interface IMBItemsEntity {
	title: string;
	speaker: string;
	url: string;
	timestamp: number;
}
export enum IPlacementKeyTypes {
	alert = "alert",
	learning = "learning",
	banner = "banner",
}
